import { Module } from 'vuex'
import {User} from "@/types/user";
import { RootState } from '@/store';

export interface UserState {
  user: User | null
}

export const user: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    user: null
  },
  mutations: {
    SET_USER(state, user: User | null) {
      state.user = user
    }
  }
}